import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=0289c560"
import script from "./Relay.vue?vue&type=script&lang=js"
export * from "./Relay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports